import React from 'react'

export default ({
  className = ''
}) => (
<svg className={className} xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 46.419 52.043">
  <path id="Export_" data-name="Export " d="M3.75-15V37.043H47.12V19.7l-4.337,4.337v8.674H8.087v-43.37h34.7v8.674L47.12,2.348V-15ZM39.327.179,36.277,3.229l5.557,5.624H20.895V13.19H41.834l-5.557,5.624,3.049,3.049,9.352-9.284,1.491-1.559L48.678,9.463Z" transform="translate(-3.75 15)"/>
</svg>
  )
